export default __webpack_public_path__ + "static/bbbc-landing-banner-mobile-693c020af36d8ab681c69e7aa2f52ff0.webp";